import * as PIXI from 'pixi.js'
import { settings } from '../settings.js'
import { isSimulate } from '../bridge.js'
import { CalculateScaleFactor } from './appConfig.js'
import { globalVolumes } from './soundManager.js'
import { tweenFadeAppear } from './utility.js'
import gsap from 'gsap'
import Stats from 'stats.js'
import { fruitData } from './data.js'
import { resizeLoadingScreen } from './assetProgressBar.js'
import { gameAssets, resizeGameUI, toggleVisibility } from './gameUI.js'

const createPixiApp = () => {
  // const maxResolution = 2; 
  // const resolution = Math.min(window.devicePixelRatio || 1, maxResolution);
  if (isAppleMobileDevice()) {
    PIXI.settings.RESOLUTION = 2
  } else {
    PIXI.settings.RESOLUTION = 2
  }

  const app = new PIXI.Application({
    backgroundColor: 0x000000,
    antialias: isDesktopDevice()
  })
  window.__PIXI_APP__ = app;

  app.stage.interactive = true;
  let isTouchActive = false;

  app.stage.on("pointerdown", (event) => {
    //     if (event.data.pointerType === 'touch') {
    //       if (isTouchActive) return; // Ignore if already touching
    //       isTouchActive = true;
    //     }

    if (gameAssets?.betPanelPopup?.visible) {
      toggleVisibility(gameAssets.betPanelPopup, false, 0.2)
    }

    if (gameAssets?.roundPanelPopup?.visible) {
      toggleVisibility(gameAssets.roundPanelPopup, false, 0.2)
    }
  })

  //   app.stage.on('pointerup', () => {
  //     isTouchActive = false;
  //   });
  //   app.stage.on('pointerupoutside', () => {
  //     isTouchActive = false;
  //   });

  if (window.innerWidth < 500) {
    fruitData.gameScreenWidth = 1440
  } else {
    fruitData.gameScreenWidth = 800
  }
  CalculateScaleFactor();

  // Initialize FPS meter
  fruitData.stats = new Stats();
  fruitData.stats.showPanel(0); // 0: FPS panel
  fruitData.stats.visible = true;
  //document.body.appendChild(fruitData.stats.dom); // Append stats panel to the DOM
  fruitData.stats.dom.style.position = 'absolute';
  fruitData.stats.dom.style.left = '50%';
  fruitData.stats.dom.style.transform = 'translateX(-50%)';


  app.renderer.view.style.width = `${window.innerWidth}px`;
  app.renderer.view.style.height = `${window.innerHeight}px`;
  app.renderer.resize(window.innerWidth, window.innerHeight);


  app.stage.alpha = 0
  gsap.delayedCall(0.7, () => {
    tweenFadeAppear(app.stage, true, 0.5)
  });

  app.view.oncontextmenu = (e) => {
    e.preventDefault();
  };

  if (isSimulate) document.getElementById('simulator').appendChild(app.view)
  else {
    if (settings.div()) { settings.div().appendChild(app.view) } else {
      document.body.innerHTML =
        `
            <div>
                <h1>Configuration error! </h1>
                    <p>
                    - Please provide proper div id in settings.js. Check getElementById
                    </p>
                    <p>
                    - If issue doesn't resolve. Talk to PixiJS developers
                </p>
            </div>
        `
    }

  }

  window.onresize = (e) => {
    if (window.innerWidth < 500) {
      fruitData.gameScreenWidth = 1440
    } else {
      fruitData.gameScreenWidth = 800
    }
    CalculateScaleFactor();
    resizePixiApplication();
    resizeLoadingScreen();
    if (fruitData.gameLoaded)
      resizeGameUI();
  }

  function resizePixiApplication() {
    app.renderer.view.style.width = `${window.innerWidth}px`;
    app.renderer.view.style.height = `${window.innerHeight}px`;
    app.renderer.resize(window.innerWidth, window.innerHeight);
  }

  function isDesktopDevice() {
    return /Win|Mac/.test(navigator.platform);
  }


  const destroyPixiApp = () => app.destroy(true)

  const appTransform = (x, y) => { //app.renderer.resize(width, height)
  }

  window.addEventListener("blur", () => { globalVolumes(0) })
  window.addEventListener("focus", () => { if (fruitData.sounds) { globalVolumes(1) } })


  // Start updating stats in the ticker
  app.ticker.add(() => {
    fruitData.stats.begin(); // Start FPS measurement
    fruitData.stats.end(); // End FPS measurement
    resetZoom();
  });

  return {
    app: app,
    destroyPixi: destroyPixiApp,
    resizePixiApp: appTransform
  }
  function resetZoom() {
    document.body.style.zoom = "100%"; // For modern browsers
    document.body.style.transform = "scale(1)";
    document.body.style.transformOrigin = "top left";
  }
}


export function isAppleMobileDevice() {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}



export default createPixiApp
